module.exports = __webpack_public_path__ + "static/media/closed-Orange.8ee5da98.svg";